import React from 'react'
import { Home } from '../../components/home'
let Component = Home

//leaving this here as an example just in case we have issues with prod and the hot reloader
if (process.env.NODE_ENV !== 'production') {
  Component = require('react-hot-loader').hot(module)(Component)
}

export default Component
